"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteRoleMutation = exports.useUpdateRoleMutation = exports.useCreateRoleMutation = exports.useUpdateRolePermissionsMutation = exports.useGetRolePermissionsQuery = exports.useGetRolesQuery = exports.useGetEffectivePermissionsQuery = exports.permissionApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var api_url_1 = require("../../utils/api-url");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.permissionApi = (0, react_1.createApi)({
    reducerPath: "permissionApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["role-permissions"],
    endpoints: function (builder) { return ({
        // The identity argument separates cached grants between sessions; the API derives the caller from the token.
        getEffectivePermissions: builder.query({
            query: function () { return "/v1/permission/me"; },
            providesTags: ["role-permissions"],
        }),
        getRoles: builder.query({
            query: function (request) { return (0, api_url_1.appendUrlParams)("/v1/roles", { client_id: request ? request.clientId : undefined }); },
            providesTags: ["role-permissions"],
        }),
        getRolePermissions: builder.query({
            query: function (request) { return (0, api_url_1.appendUrlParams)("/v1/permission/role-defaults", { client_id: request ? request.clientId : undefined }); },
            providesTags: ["role-permissions"],
        }),
        updateRolePermissions: builder.mutation({
            query: function (_a) {
                var role = _a.role, clientId = _a.clientId, permissions = _a.permissions;
                return ({
                    url: "/v1/permission/role-defaults/".concat(role),
                    method: "PATCH",
                    body: { permissions: permissions, client_id: clientId },
                });
            },
            invalidatesTags: ["role-permissions"],
        }),
        createRole: builder.mutation({
            query: function (_a) {
                var name = _a.name, description = _a.description, clientId = _a.clientId;
                return ({
                    url: "/v1/roles",
                    method: "POST",
                    body: { name: name, description: description, client_id: clientId },
                });
            },
            invalidatesTags: ["role-permissions"],
        }),
        updateRole: builder.mutation({
            query: function (_a) {
                var role = _a.role, name = _a.name, description = _a.description, clientId = _a.clientId;
                return ({
                    url: "/v1/roles/".concat(role),
                    method: "PATCH",
                    body: { name: name, description: description, client_id: clientId },
                });
            },
            invalidatesTags: ["role-permissions"],
        }),
        deleteRole: builder.mutation({
            query: function (_a) {
                var role = _a.role, clientId = _a.clientId;
                return ({
                    url: (0, api_url_1.appendUrlParams)("/v1/roles/".concat(role), { client_id: clientId }),
                    method: "DELETE",
                });
            },
            invalidatesTags: ["role-permissions"],
        }),
    }); },
});
exports.useGetEffectivePermissionsQuery = exports.permissionApi.useGetEffectivePermissionsQuery, exports.useGetRolesQuery = exports.permissionApi.useGetRolesQuery, exports.useGetRolePermissionsQuery = exports.permissionApi.useGetRolePermissionsQuery, exports.useUpdateRolePermissionsMutation = exports.permissionApi.useUpdateRolePermissionsMutation, exports.useCreateRoleMutation = exports.permissionApi.useCreateRoleMutation, exports.useUpdateRoleMutation = exports.permissionApi.useUpdateRoleMutation, exports.useDeleteRoleMutation = exports.permissionApi.useDeleteRoleMutation;
